export const STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  FINISHED: 'finished',
} as const;

export const SEND_TIMEOUT = 1000;
